module.exports = __webpack_public_path__ + "img/26.db2f97f7.png";